import React from "react";
import "../common/styles/styles.css";
import { useState, useEffect } from "react";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";

function Contact() {
  // useEffect(()=>{
  //   window.addEventListener("load", function() {
  //     const form = document.getElementById('my-form');
  //     form.addEventListener("submit", function(e) {
  //       e.preventDefault();
  //       const data = new FormData(form);
  //       const action = e.target.action;
  //       fetch(action, {
  //         method: 'POST',
  //         body: data,
  //       })
  //       .then(() => {
  //         alert("Success!");
  //       })
  //     });
  //   });
  // })

  useEffect(() => {
    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxczOnNOfsDea4DBme1GX11x7rTkE5tJl7-nKe8y40Y-GhD99aoKhu3KNung-kl4SMF/exec";
    const form = document.forms["submit-to-google-sheet"];

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      fetch(scriptURL, { method: "POST", body: new FormData(form) })
        .then((response) => {
          form.reset();
        })
        .catch((error) => console.error("Error!", error.message));
    });
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    openModal();
    // Perform your form submission logic here
  };
  const lineHeight = {
    hidden: { height: 0 },
    show: { height: "95%" },
  };

  const horizontalLine = {
    hidden: { x: "100%", opacity: 0 }, // Start from the right and hidden
    show: { x: "0%", opacity: 1 },
  };
  return (
    <>
      <div className="relative ">
        <motion.div
          variants={lineHeight}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false }}
          transition={{ duration: 0.9, delay: 0.5 }}
          style={{ transformOrigin: "top-right" }}
          className="snakeline absolute w-[10px] h-full increase1 mt-10 right-0 rounded-full"
        ></motion.div>
        <motion.div
          variants={horizontalLine}
          initial="hidden"
          whileInView="show"
          exit="hidden"
          viewport={{ once: false }}
          transition={{ duration: 0.9, delay: 1 }}
          className="snakeline absolute -bottom-12 h-[10px] w-full increase1 origin-bottom-right"
        ></motion.div>
        {/* <motion.div variants={horizontalLine} initial="hidden" whileInView='show' viewport={{once:false}} transition={{duration:0.9, delay:1.3}}
    style={{transformOrigin:'bottom'}}
    className='absolute w-full h-[10px] increase1 -bottom-12 origin-right  rounded-full '></motion.div> */}

        <div className="contact ">
          <div className="flex flex-col flex-wrap mx-auto md:flex-row xl:justify-center md:mt-20 xl:flex-nowrap">
            <h2 className="max-w-md px-8 pt-10 text-3xl font-semibold md:text-5xl font-Poppins ">
              Ready to take your impact creation to the next level?{" "}
            </h2>

            <div className="relative m-8 sm:m-8 font-Inter">
              <form
                className=""
                name="submit-to-google-sheet"
                id="my-form"
                onSubmit={handleSubmit}
              >
                <Modal
                  shouldCloseOnOverlayClick={false}
                  isOpen={isOpen}
                  onRequestClose={closeModal}
                  contentLabel="Modal"
                  overlayClassName="fixed inset-0 bg-black bg-opacity-70"
                  className="overflow-hidden z-50 w-[85%] h-[25%] top-[30%] left-[8%] md:w-[45%] md:top-[35%] md:left-[28%] absolute  p-10 text-custom-dark bg-custom-grey font-Roboto rounded-lg"
                >
                  <div className="flex justify-between">
                    <h2 className="pb-4 text-3xl font-semibold">
                      Form Submitted
                    </h2>
                    <CloseIcon
                      onClick={closeModal}
                      className="absolute cursor-pointer right-3 top-6 text-sustally-violet z-100"
                      style={{ fontSize: "30px" }}
                    />
                  </div>
                  <p className="text-xl">
                    Thanks for reaching out to us. We will get in touch with you
                    shortly.
                  </p>
                </Modal>

                <p className="py-2 text-xl font-semibold md:text-3xl">
                  My name is{" "}
                  <span className="py-1 border-b border-custom-purple">
                    <input
                      required
                      className="px-2 py-1 leading-tight bg-transparent border-none appearance-none text-white-700 focus:outline-non"
                      type="text"
                      name="Name"
                      placeholder="Tony Stark"
                      aria-label="Full name"
                    ></input>
                  </span>
                  .
                </p>

                {/* <div className='py-1 text-xl font-semibold contact-footer md:text-3xl max-w-7xl'> */}
                {/* <h2 className='py-1 text-lg font-semibold sm:text-2xl'>I am <span className='py-1 border-b border-custom-purple'><input required className="px-2 py-1 leading-tight bg-transparent border-none appearance-none text-white-700 focus:outline-non" type="text" name="Position" placeholder="CEO" aria-label="Full name"></input></span>, p</h2> */}
                <label
                  htmlFor="position"
                  className="block text-xl font-semibold md:text-3xl"
                >
                  I am{" "}
                  <span className="py-1 border-b border-custom-purple">
                    <select
                      id="position"
                      name="position"
                      className="px-2 py-1 font-semibold leading-tight text-white bg-transparent border border-none opacity-75 appearance-none text-md focus:outline-none"
                    >
                      <option className="text-white bg-gray-800">CXO</option>
                      <option className="text-white bg-gray-800">
                        Founder
                      </option>
                      <option className="text-white bg-gray-800">
                        Functional Lead
                      </option>
                      <option className="text-white bg-gray-800">
                        Sustainability Team
                      </option>
                      <option className="text-white bg-gray-800">
                        HR Team
                      </option>
                      <option className="text-white bg-gray-800">
                        Operations Lead
                      </option>
                      <option className="text-white bg-gray-800">
                        General Admin Team
                      </option>
                      <option className="text-white bg-gray-800">
                        Team Member
                      </option>
                    </select>
                  </span>
                </label>

                <p className="py-2 text-xl font-semibold md:text-3xl">
                  part of
                  <span className="py-1 border-b border-custom-purple">
                    <input
                      required
                      className="px-2 py-1 leading-tight bg-transparent border-none appearance-none text-white-700 focus:outline-non"
                      type="text"
                      name="Company"
                      placeholder="Stark Industries"
                      aria-label="Full name"
                    ></input>
                  </span>
                  team.
                </p>
                {/* </div> */}
                <p className="py-2 text-xl font-semibold md:text-3xl">
                  I am interested in{" "}
                  <span className="py-1 border-b border-custom-purple">
                    <input
                      required
                      className="px-2 py-1 leading-tight bg-transparent border-none appearance-none text-white-700 focus:outline-non"
                      name="Purpose"
                      type="text"
                      placeholder="interacting with your team"
                      aria-label="Full name"
                    ></input>
                  </span>
                  .
                </p>
                <p className="py-2 text-xl font-semibold md:text-3xl">
                  I'd like to meet with your team, you can contact me at{" "}
                </p>
                <div className="py-2 text-xl font-semibold contact-footer md:text-3xl">
                  <span className="py-1 text-xl font-semibold border-b border-custom-purple md:text-3xl">
                    <input
                      required
                      className="px-2 py-1 leading-tight bg-transparent border-none appearance-none text-white-700 focus:outline-non"
                      type="text"
                      name="Email"
                      placeholder="tony@stark.com"
                      aria-label="Full name"
                    ></input>
                  </span>
                  <p className="py-1 ml-1 mr-1 text-xl font-semibold md:text-3xl">
                    Or
                  </p>
                  <span className="py-1 text-xl font-semibold border-b md:text-3xl border-custom-purple">
                    <input
                      required
                      className="px-2 py-1 leading-tight bg-transparent border-none appearance-none text-white-700 focus:outline-non"
                      type="text"
                      name="Phone"
                      placeholder="+91 12345 67890"
                      aria-label="Full name"
                    ></input>
                  </span>
                </div>
                {/* <Button/> */}
                <button
                  aria-label="Submit Form"
                  name="submit"
                  type="submit"
                  className="btn rounded font-Roboto md:absolute md:left-[40%] "
                >
                  <span className="text-green">Submit</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
